<div *ngIf="user">
  <div class="avatar-container d-flex">
    <img src="{{ user.picture }}" alt="User avatar" class="user-avatar" />
    <h3>{{ user.name }}</h3>
  </div>
  <ul class="list-group list-group-flush">
    <li class="list-group-item"><strong>Email:</strong> {{ user.email }}</li>
    <li class="list-group-item">
      <strong>Phone:</strong>
      <span *ngIf="user.phone">+{{ user.countryCode }} {{ user.phone }} </span>
    </li>
    <li *ngIf="user.userId" class="list-group-item">
      <strong>User ID:</strong> {{ user.userId }}
    </li>
    <li *ngIf="accountId" class="list-group-item">
      <strong>Account ID:</strong>
      <a routerLink="/au/accounts/{{ accountId }}">
        <span>{{ accountId }}</span>
      </a>
    </li>
    <li class="list-group-item roles">
      <strong>Back Office Roles:</strong>
      <app-user-roles
        (updateUserRoles)="onUpdateUserRoles($event)"
        [roles]="user.roles || []"
        [isEditable]="true"
        [userPermissions]="userPermissions"
        [userRoles]="userRoles"
        [isUpdatingRole]="isUpdatingRole"
      ></app-user-roles>
    </li>
    <li *ngIf="user.lastLogin" class="list-group-item">
      <strong>Back Office last login:</strong>
      {{ user.lastLogin | date: 'yyyy/MM/dd H:mm' }}
    </li>
  </ul>
</div>
